import { render } from "./AppTag.vue?vue&type=template&id=217d42e2&scoped=true&ts=true"
import script from "./AppTag.vue?vue&type=script&lang=ts"
export * from "./AppTag.vue?vue&type=script&lang=ts"

import "./AppTag.vue?vue&type=style&index=0&id=217d42e2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217d42e2"]])

export default __exports__